import { useEffect } from 'react';

const useOnResize = (callback, scope) => {
  useEffect(() => {
    let timeoutId = null;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback(), 100);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", handleResize);
    };
  }, scope);
};

export { useOnResize };
//# sourceMappingURL=use-on-resize.js.map
